
import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';

import "react-datepicker/dist/react-datepicker.css";

registerLocale('es', es);
setDefaultLocale('es')


const DateRangePicker = (props) => {

  const [startDate, setStartDate] = useState(props.startDate);
  const [endDate, setEndDate] = useState(props.endDate);

  useEffect(() => {
    setStartDate(props.startDate);
    setEndDate(props.endDate);
  }, [props]);

  const onChange = (date) => {

    if (endDate) {
      setStartDate(date);
      setEndDate(null);
    }
    else if (date > startDate) {
      setEndDate(date);
      props.onSelect([startDate, date]);
    } else {
      setStartDate(date);
    }
  };
  
  return (
    <DatePicker
      selectsRange={true}
      value={`${startDate? startDate.toLocaleDateString("es") : ""} - ${endDate? endDate.toLocaleDateString("es") : ""}`}
      startDate={startDate}
      endDate={endDate}
      onChange={onChange}
      shouldCloseOnSelect={false}
      openToDate={startDate}
      className='btn btn-outline-dark'
      todayButton="Hoy"
      showYearDropdown
    />
  );
}

export default DateRangePicker;
